<template>

  <!-- On Delivery (TO_SHIPPER, AT_SHIPPER, PICKED_UP, TO_RECEIVER, AT_RECEIVER) -->
  <order-list-data-table
      title="On Delivery"
      defaultSortField="scheduled_delivery"
      defaultSortOrder="asc"
      routeClickGoTo="delivery-stepper"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      :linkToLocations="true"
      :allowRevealConfirmCode="true" />

</template>

<script>
import OrderListDataTable from '@/components/orders/OrderListDataTable'

export default {
  name: 'OrderListOnDeliveryPage',

  components: {
    OrderListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Order #', value: 'order_number' },
        // { text: 'Provider', value: 'provider_alias' },
        // { text: 'Account', value: 'thirdparty_account_name' },
        { text: 'Brand', width: '140px', value: 'thirdparty_brand_name' },
        { text: 'Route', value: 'route_id' },
        { text: 'From', value: 'shipper.name' },
        { text: 'To', value: 'receiver.name' },
        { text: 'Scheduled Delivery', value: 'scheduled_delivery', align: 'center' },
        { text: 'Est. Pickup', value: 'estimated_shipper_arrival_time' },
        { text: 'Est. at Receiver', value: 'estimated_receiver_arrival_time' },
        { text: 'Confirm Code', sortable: false, value: 'confirm_code' },
        { text: 'Status', value: 'order_status' }
      ],
      status: ['TO_SHIPPER', 'AT_SHIPPER', 'PICKED_UP', 'TO_RECEIVER', 'AT_RECEIVER'],
      assocs: 'shipper,receiver,order_details,confirm_code,parent_order,route'
    }
  }
}
</script>

<style scoped>
</style>
